import { styled, Grid } from "@mui/material";

export const GridContainer = styled(Grid)(({ theme }) => ({
  height: "100%",
  padding: theme.spacing(0, 2),
}));
